import { Select, Space, Typography } from 'antd';
import { useIntl } from 'react-intl';
import type { InventoryLocale } from '@/shared/i18n/inventory-i18n';
import { languageOptionMessages, messages } from './messages';

const languageOptions = [
  { message: languageOptionMessages.en, value: 'en' },
  { message: languageOptionMessages.cs, value: 'cs' },
  { message: languageOptionMessages.sk, value: 'sk' },
  { message: languageOptionMessages.pl, value: 'pl' },
] satisfies Array<{
  message: (typeof languageOptionMessages)[keyof typeof languageOptionMessages];
  value: InventoryLocale;
}>;

export function LanguageSwitcher({
  compact = false,
  onChange,
  value,
}: {
  compact?: boolean;
  onChange: (locale: InventoryLocale) => void;
  value: InventoryLocale;
}) {
  const intl = useIntl();
  const label = intl.formatMessage(messages.languageLabel);

  return (
    <Space orientation={compact ? 'horizontal' : 'vertical'} size={compact ? 6 : 4}>
      {compact ? null : <Typography.Text type="secondary">{label}</Typography.Text>}
      <Select
        aria-label={label}
        onChange={onChange}
        options={languageOptions.map(option => ({
          label: intl.formatMessage(option.message),
          value: option.value,
        }))}
        size={compact ? 'middle' : 'large'}
        style={{ minWidth: compact ? 132 : 180 }}
        value={value}
      />
    </Space>
  );
}
